import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const getUIDesignReport = async ({ testCaseResultsId, testStepId, principleLevel }) => {
  const user = getUserDetails();
  let url = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getUIDesignReport&companyid=${user.companyid}&testCaseResultsId=${testCaseResultsId}`;
  if (testStepId) {
    url += `&testStepId=${testStepId}`;
  }
  if (principleLevel) {
    url += `&principleLevel=${principleLevel}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const useGetUIDesignReportQuery = (testCaseResultsId, options = {}) => {
  const { testStepId, principleLevel, ...queryOptions } = options;
  return useQuery({
    queryKey: ["getUIDesignReport", testCaseResultsId, testStepId ?? null, principleLevel ?? null],
    queryFn: () => getUIDesignReport({ testCaseResultsId, testStepId, principleLevel }),
    enabled: !!testCaseResultsId,
    ...queryOptions,
  });
};

export default useGetUIDesignReportQuery;
